import { FileDownload as FileDown } from "@mui/icons-material";
import { Button, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import toast from "react-hot-toast";

import {
    DocumentInfo,
    DocumentSection,
} from "../../../../../../../../models/documents";
import {
    TBudgetProfile,
    TReadBudgetsResponse,
} from "../../../../../../../../services/budget/read-budgets";
import { TReadBudgetsLevelsDetailsByIdResponse } from "../../../../../../../../services/budget/read-budgets-levels-detailed-by-id";
import {
    generateDOCX,
    generatePDF,
} from "../../../../../../../../utils/document";

interface IDocumentDownloadProps {
    sections: DocumentSection[];
    documentInfo: DocumentInfo;
    profiles: TBudgetProfile[];
    budgetData: TReadBudgetsResponse;
    tableScopeData: TReadBudgetsLevelsDetailsByIdResponse;
}

export default function DocumentDownload({
    sections,
    documentInfo,
    budgetData,
    profiles,
    tableScopeData,
}: IDocumentDownloadProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handlePdfDownload = async () => {
        try {
            await generatePDF(
                sections,
                documentInfo,
                profiles,
                budgetData,
                tableScopeData
            );
            toast.success("Documento baixado como PDF com sucesso!");
            handleClose();
        } catch (error) {
            console.error("Erro ao gerar PDF:", error);
            toast.error(
                "Erro ao baixar o documento como PDF. Tente novamente."
            );
        }
    };

    const handleDocxDownload = async () => {
        try {
            await generateDOCX(
                sections,
                documentInfo,
                profiles,
                budgetData,
                tableScopeData
            );
            toast.success("Documento baixado como DOCX com sucesso!");
            handleClose();
        } catch (error) {
            console.error("Erro ao gerar DOCX:", error);
            toast.error(
                "Erro ao baixar o documento como DOCX. Tente novamente."
            );
        }
    };

    return (
        <>
            <Button
                variant="outlined"
                startIcon={<FileDown />}
                onClick={handleClick}
            >
                Baixar Documento
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem onClick={handlePdfDownload}>Como PDF (.pdf)</MenuItem>
                <MenuItem onClick={handleDocxDownload}>
                    Como Word (.docx)
                </MenuItem>
            </Menu>
        </>
    );
}
